import RolesHelper from "./RolesHelper";

const CanDoAction = ({ children, isOrganization }) => {
  const will_return_children = RolesHelper?.help_determine_via_role(isOrganization);

  return will_return_children ? children : null;
};
export default CanDoAction;
